import { mockServerAjaxPromise } from './request_helpers';

const MOCK_BASE_URL = 'https://d01a2710-634b-4927-9557-cf5fd09bd4e0.mock.pstmn.io/v0';
const MOCK_API_KEY = 'PMAK-6008f7f029234c00298966e9-809a5324978738b19a2a556ad745114d17';

const getOptions = userId => {
  return mockServerAjaxPromise(
    {
      type: 'GET',
      contentType: 'application/json',
      url: `${MOCK_BASE_URL}/users/${userId}/feeds`,
      data: {}
    },
    MOCK_API_KEY
  );
};

const getFeed = url => {
  return mockServerAjaxPromise(
    {
      type: 'GET',
      contentType: 'application/json',
      url
    },
    MOCK_API_KEY
  );
};

export { getOptions, getFeed, MOCK_BASE_URL };
